import { createConsumer } from '@rails/actioncable';

class CouriersConnector {
  constructor(store) {
    const { websocketURL = '' } = window.chatwootConfig || {};
    const cableURL = websocketURL ? `${websocketURL}/cable` : undefined;
    this.consumer = createConsumer(cableURL);
    this.subscription = null;
    this.store = store;
  }

  subscribe() {
    if (this.subscription) {
      return;
    }

    this.subscription = this.consumer.subscriptions.create(
      { channel: 'CouriersChannel' },
      {
        received: this.onReceived,
      }
    );
  }

  onReceived = data => {
    this.store.commit('couriers/setVersion', {
      version: data.version,
      nextUpdateAt: data.next_update_at,
    });
  };

  disconnect() {
    if (this.subscription) {
      this.consumer.subscriptions.remove(this.subscription);
      this.subscription = null;
    }
  }
}

export default CouriersConnector;
